/* THE SKILLS FULL CART RECOVERY CONSOLE V1 */
(() => {
  if (window.__skillsFullRecoveryCartReady) return;
  window.__skillsFullRecoveryCartReady = true;

  const rootUrl = () => window.Shopify?.routes?.root || '/';

  const parseHTML = (html) =>
    new DOMParser().parseFromString(html, 'text/html');

  const getRequestedSections = () => {
    const itemSection = document.getElementById('main-cart-items')?.dataset.id;
    const footerSection = document.getElementById('main-cart-footer')?.dataset.id;

    return [
      'cart-drawer',
      'cart-icon-bubble',
      itemSection,
      footerSection
    ].filter((value, index, array) => value && array.indexOf(value) === index);
  };

  const replaceSectionWrapper = (sectionId, html) => {
    if (!sectionId || !html) return;

    const current = document.getElementById(`shopify-section-${sectionId}`);
    if (!current) return;

    const parsed = parseHTML(html);
    const source =
      parsed.getElementById(`shopify-section-${sectionId}`) ||
      parsed.querySelector('.shopify-section');

    if (source) current.innerHTML = source.innerHTML;
  };

  const replaceDrawer = (html) => {
    if (!html) return;

    const current = document.querySelector('#CartDrawer');
    const source = parseHTML(html).querySelector('#CartDrawer');

    if (current && source) current.innerHTML = source.innerHTML;
  };

  const renderSections = (state, requestedSections) => {
    const sections = state?.sections;
    if (!sections) {
      window.location.reload();
      return;
    }

    replaceDrawer(sections['cart-drawer']);
    replaceSectionWrapper('cart-icon-bubble', sections['cart-icon-bubble']);

    requestedSections.forEach((sectionId) => {
      if (sectionId === 'cart-drawer' || sectionId === 'cart-icon-bubble') return;
      replaceSectionWrapper(sectionId, sections[sectionId]);
    });

    bindThresholdSystems();
    publishRecoveryPoints();

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: state }
      })
    );
  };

  const cartChange = async ({ line, quantity, sellingPlan }) => {
    const sections = getRequestedSections();
    const payload = {
      line,
      quantity,
      sections,
      sections_url: window.location.pathname
    };

    if (sellingPlan !== undefined) {
      payload.selling_plan = sellingPlan || null;
    }

    const response = await fetch(`${rootUrl()}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const state = await response.json();

    if (!response.ok) {
      throw new Error(
        state?.description ||
        state?.message ||
        'Could not update the cart.'
      );
    }

    renderSections(state, sections);
  };

  const addProduct = async (button) => {
    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'ADDING';

    try {
      const sections = getRequestedSections();
      const response = await fetch(`${rootUrl()}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections,
          sections_url: window.location.pathname
        })
      });

      const state = await response.json();

      if (!response.ok) {
        throw new Error(
          state?.description ||
          state?.message ||
          'Could not add product.'
        );
      }

      renderSections(state, sections);
    } catch (error) {
      console.error('[FULL RECOVERY CART ADD]', error);
      window.alert(error.message);
      button.disabled = false;
      button.textContent = original;
    }
  };

  document.addEventListener(
    'change',
    (event) => {
      const control = event.target.closest('[data-skills-cart-plan]');
      if (!control) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      cartChange({
        line: Number(control.dataset.line),
        quantity: Number(control.dataset.quantity || 1),
        sellingPlan: control.value ? Number(control.value) : null
      }).catch((error) => {
        console.error('[FULL RECOVERY CART PLAN]', error);
        window.alert(error.message);
      });
    },
    true
  );

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-skills-cart-add]');
    if (!addButton) return;

    event.preventDefault();
    addProduct(addButton);
  });

  function bindThresholdSystems() {
    document.querySelectorAll('[data-cart-threshold-system]').forEach((system) => {
      if (system.dataset.bound === 'true') return;
      system.dataset.bound = 'true';

      const triggers = Array.from(
        system.querySelectorAll('[data-cart-threshold-trigger]')
      );
      const panels = Array.from(
        system.querySelectorAll('[data-cart-threshold-panel]')
      );

      let activeTier = null;
      let openTimer = null;
      let closeTimer = null;

      const isMobile = () =>
        window.matchMedia('(max-width: 749px)').matches;

      const getTrigger = (tier) =>
        triggers.find((item) => item.dataset.cartThresholdTrigger === tier);

      const getPanel = (tier) =>
        panels.find((item) => item.dataset.cartThresholdPanel === tier);

      const closeTier = (tier = activeTier) => {
        if (!tier) return;

        const trigger = getTrigger(tier);
        const panel = getPanel(tier);

        trigger?.classList.remove('is-active');
        trigger?.setAttribute('aria-expanded', 'false');

        if (panel) panel.hidden = true;
        if (activeTier === tier) activeTier = null;
      };

      const openTier = (tier) => {
        window.clearTimeout(openTimer);
        window.clearTimeout(closeTimer);

        if (activeTier && activeTier !== tier) closeTier(activeTier);

        const trigger = getTrigger(tier);
        const panel = getPanel(tier);
        if (!trigger || !panel) return;

        activeTier = tier;
        trigger.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      };

      const scheduleOpen = (tier) => {
        window.clearTimeout(closeTimer);
        openTimer = window.setTimeout(() => openTier(tier), 170);
      };

      const scheduleClose = (tier) => {
        window.clearTimeout(openTimer);
        closeTimer = window.setTimeout(() => {
          const trigger = getTrigger(tier);
          const panel = getPanel(tier);

          if (!trigger?.matches(':hover') && !panel?.matches(':hover')) {
            closeTier(tier);
          }
        }, 340);
      };

      triggers.forEach((trigger) => {
        const tier = trigger.dataset.cartThresholdTrigger;

        trigger.addEventListener('pointerenter', () => {
          if (!isMobile()) scheduleOpen(tier);
        });

        trigger.addEventListener('pointerleave', () => {
          if (!isMobile()) scheduleClose(tier);
        });

        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          activeTier === tier ? closeTier(tier) : openTier(tier);
        });
      });

      panels.forEach((panel) => {
        const tier = panel.dataset.cartThresholdPanel;

        panel.addEventListener('pointerenter', () => {
          if (!isMobile()) window.clearTimeout(closeTimer);
        });

        panel.addEventListener('pointerleave', () => {
          if (!isMobile()) scheduleClose(tier);
        });
      });
    });
  }

  function publishRecoveryPoints() {
    const cart = document.querySelector('.skills-recovery-cart');
    if (!cart) return;

    document.dispatchEvent(
      new CustomEvent('skills:recovery_points_updated', {
        bubbles: true,
        detail: {
          score: Number(cart.dataset.recoveryScore || 0),
          level: cart.dataset.recoveryLevel || 'RESET',
          source: 'full-recovery-cart'
        }
      })
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindThresholdSystems();
    publishRecoveryPoints();
  });


  function bindRoutineReveal() {
    const reveal = document.querySelector('[data-cart-routine-reveal]');
    if (!reveal || reveal.dataset.routineRevealBound === 'true') return;

    reveal.dataset.routineRevealBound = 'true';

    let openTimer = null;
    let closeTimer = null;

    reveal.addEventListener('pointerenter', () => {
      if (window.matchMedia('(max-width: 749px)').matches) return;

      window.clearTimeout(closeTimer);
      openTimer = window.setTimeout(() => {
        reveal.open = true;
      }, 180);
    });

    reveal.addEventListener('pointerleave', () => {
      if (window.matchMedia('(max-width: 749px)').matches) return;

      window.clearTimeout(openTimer);
      closeTimer = window.setTimeout(() => {
        reveal.open = false;
      }, 340);
    });

    reveal.addEventListener('toggle', () => {
      window.clearTimeout(openTimer);
      if (reveal.open) window.clearTimeout(closeTimer);
    });
  }

  document.addEventListener('DOMContentLoaded', bindRoutineReveal);
  document.addEventListener('cart:updated', bindRoutineReveal);

})();